import { useEffect, useMemo, useState, useCallback } from 'react';
import * as anchor from '@project-serum/anchor';

import styled from 'styled-components';
import {
  Container,
  Snackbar,
  Button
} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import { useWallet } from '@solana/wallet-adapter-react';
import { WalletDialogButton } from '@solana/wallet-adapter-material-ui';
import { AlertState } from './utils';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { sendNfts, getNfts } from './nft-send';

const ConnectButton = styled(WalletDialogButton)`
  width: 100%;
  height: 100px;
  margin-top: 10px;
  margin-bottom: 5px;
  background: #7a8a8a;
  color: #00F541;
  font-size: 19px;
  font-weight: bold;
`;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    testNft: {
      border: 'green 1px solid',
      width: '5%',
    },
    sendButton: {
      color: 'black',
      width: '100%',
      fontWeight: 'bolder'
    }
  }),
);

export interface HomeProps {
  connection: anchor.web3.Connection;
  txTimeout: number;
  rpcHost: string;
}

const Home = (props: HomeProps) => {
  const classes = useStyles();

  const [nfts, setNfts] = useState<any>(['']);
  const [selectedNfts, setSelectedNfts] = useState<any>([]);
  const [alertState, setAlertState] = useState<AlertState>({
    open: false,
    message: '',
    severity: undefined,
  });

  const rpcUrl = props.rpcHost;
  const wallet = useWallet();

  const anchorWallet = useMemo(() => {
    if (
      !wallet ||
      !wallet.publicKey ||
      !wallet.signAllTransactions ||
      !wallet.signTransaction
    ) {
      return;
    }

    return {
      publicKey: wallet.publicKey,
      signAllTransactions: wallet.signAllTransactions,
      signTransaction: wallet.signTransaction,
    } as anchor.Wallet;
  }, [wallet]);

  const ListComponent = (props: any) => {
    return (
      <img src={props.nft.uri} alt={props.nft.tokenAddress} onClick={() => {
        if (selectedNfts.length >= 2) {
          console.log('CANT ADD MORE');
        } else {
          const nftToBeAdded = { uri: props.nft.uri, tokenAddress: props.nft.tokenAddress, rarity: props.nft.rarity, type: props.nft.type }
          if (selectedNfts.length >= 1 && selectedNfts[0].rarity !== nftToBeAdded.rarity) {
            console.log('NFTs not same rarity');
            setAlertState({
              open: true,
              message: 'NFTs not the same RARITY',
              severity: 'error',
            });
          } else if (selectedNfts.length >= 1 && selectedNfts[0].type !== nftToBeAdded.type) {
            console.log('NFTs not same TYPE');
            setAlertState({
              open: true,
              message: 'NFTs not the same TYPE',
              severity: 'error',
            });
          } else {
            setSelectedNfts([...selectedNfts, nftToBeAdded]);
            const newList = nfts;
            const index = nfts.map((i: any) => i.tokenAddress).indexOf(props.nft.tokenAddress);
            newList.splice(index, 1);
            setNfts(newList);
          }
        }
      }}
      className="testNft"></img>
    );
  };

  const SelectedNftComponent = (props: any) => {
    return (
      <img src={props.nft.uri} alt={props.nft.tokenAddress} 
      onClick={() => {
        const nftToBeAdded = { uri: props.nft.uri, tokenAddress: props.nft.tokenAddress };
        setNfts([...nfts, nftToBeAdded])

        const newList = selectedNfts;
        const index = selectedNfts.map((i: any) => i.tokenAddress).indexOf(props.nft.tokenAddress);
        newList.splice(index, 1);
        setSelectedNfts(newList);
      }
      }
      className="testNft"></img>
    );
  };

  useEffect(() => {
    ;(async () => {
        if (
            !wallet ||
            !wallet.publicKey ||
            !wallet.signAllTransactions ||
            !wallet.signTransaction
        ) {
            return;
        }

        const walletNfts: any = await getNfts(wallet);
        setNfts(walletNfts);
    })()
  }, [
    anchorWallet,
    props.connection
  ])

  return (
    <Container style={{ marginTop: 100 }}>
        <div>
          <h1 className="selectedHeading">OWNED NFTS</h1>
        {nfts.map((item: any, i: any) => {
        return (<ListComponent key={i} nft={item}/>)
        }
        )}
        </div>

        <div>
          <h1 className="selectedHeading">SELECTED NFTS</h1>
        {selectedNfts.map((item: any, i: number) => {
        return (<SelectedNftComponent key={i} nft={item}/>)
        }
        )}
        </div>
      <Container maxWidth="xs" style={{ position: 'relative' }}>
        <Paper
          style={{ padding: 24, backgroundColor: '#151A1F', borderRadius: 6 }}
        >
          {!wallet.connected ? (
            <ConnectButton>Connect Wallet</ConnectButton>
          ) : (
            <>
            <Button variant="contained" color="primary" className={classes.sendButton} onClick={async () => {
              const nftAddresses = [];
              for await (const nftToken of selectedNfts) {
                nftAddresses.push(nftToken.tokenAddress)
              }
              const result = await sendNfts(wallet, nftAddresses);
              if (!result) {
                setAlertState({
                  open: true,
                  message: 'Please try again, server is unavailable',
                  severity: 'error',
                });
              }
              setSelectedNfts([]);
            }}>SEND NFTS</Button>
            </>
          )}
        </Paper>
      </Container>

      <Snackbar
        open={alertState.open}
        autoHideDuration={6000}
        onClose={() => setAlertState({ ...alertState, open: false })}
      >
        <Alert
          onClose={() => setAlertState({ ...alertState, open: false })}
          severity={alertState.severity}
        >
          {alertState.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Home;
